import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoaderSubitoService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  /**
   * Muestra el loader hasta que se llame explícitamente a hideLoader()
   */
  public showLoader(): void {
    this.isLoadingSubject.next(true);
  }

  /**
   * Oculta el loader con una transición suave
   */
  public hideLoader(): void {
    if(!this.isBrowser) return;
    // Obtenemos todos los elementos del loader
    const loaderElements = document.querySelectorAll('.fixed.inset-0.flex.items-center.justify-center');

    // Aplicamos la clase de opacidad para iniciar la transición
    loaderElements.forEach(element => {
      element.classList.add('opacity-0');
    });

    // Esperamos a que termine la transición antes de ocultar completamente
    setTimeout(() => {
      this.isLoadingSubject.next(false);
    }, 500); // Este tiempo debe coincidir con la duración de la transición en el CSS
  }
}